import React from 'react'
import { ArrayInput, SimpleFormIterator } from 'react-admin'
import KAccordion from 'ui-shared/accordions/KAccordion'
import OptionGroupInput from './OptionGroupInput'

const CatalogOptionsInput: React.FC = () => (
  <KAccordion accordionTitle="Options">
    <ArrayInput source="options">
      <SimpleFormIterator>
        <OptionGroupInput />
      </SimpleFormIterator>
    </ArrayInput>
  </KAccordion>
)

export default CatalogOptionsInput
